<style src="./PopOptionsEmandamento.scss" lang="scss" scoped></style>
<template>
  <ul class="pop-options-emandamento">
    <li
      class="item"
      :class="{ 'selected': selection === 'ACEITAÇÃO' }"
      @click="select('ACEITAÇÃO')">ACEITAÇÃO</li>
    <li
      class="item"
      :class="{ 'selected': selection === 'HABILITAÇÃO' }"
      @click="select('HABILITAÇÃO')">HABILITAÇÃO</li>
    <li
      class="item"
      :class="{ 'selected': selection === 'EM-LANCE' }"
      @click="select('EM-LANCE')">EM LANCE</li>
    <li class="sep"></li>
    <li
      class="item"
      :class="{ 'selected': metaSelection && metaSelection.metaStatus === 'AGUARDANDO' }"
      @click="selectMeta('AGUARDANDO')">AGUARDANDO</li>
    <li
      class="item item__return"
      :class="{ 'selected': metaSelection && metaSelection.metaStatus === 'RETORNA-EM' }">
      <datebox
        v-model="form.returnDate"
        placeholder="Data de retorno"
        class="datebox" />
      <button
        class="button-filter btn-primary"
        @click="selectMetaData"><icon-right-arrow /></button>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import { Datebox } from '@/components/primitives'
import { IconRightArrow } from '@/components/primitives/icons'
import moment from 'moment'

export default {
  name: 'PopOptionsEmandamento',
  components: {
    Datebox,
    IconRightArrow
  },
  props: {
    popupFilters: {
      default: null
    }
  },
  data () {
    return {
      form: {
        returnDate: ''
      }
    }
  },
  watch: {
    metaSelection: {
      handler (filters) {
        if (filters && filters.returnDate) {
          this.form.returnDate = moment(filters.returnDate).format('DD/MM/YYYY')
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      selection: 'Board/GET_EMANDAMENTO_STATUS',
      metaSelection: 'Board/GET_EMANDAMENTO_META_STATUS'
    })
  },
  methods: {
    select (emandamento) {
      if (emandamento === this.selection) {
        this.$store.commit('Board/SET_FILTER', { emandamento: null })
      } else {
        this.$store.commit('Board/SET_FILTER', { emandamento })
      }
    },
    selectMeta (metaStatus) {
      if (this.metaSelection && metaStatus === this.metaSelection.metaStatus) {
        this.$store.commit('Board/SET_FILTER_META', { meta: false })
      } else {
        this.$store.commit('Board/SET_FILTER_META', { meta: { metaStatus } })
      }
    },
    selectMetaData () {
      if (this.form.returnDate.trim().length === 0) {
        this.$store.commit('Board/SET_FILTER_META', { meta: false })
      } else {
        this.$store.commit('Board/SET_FILTER_META', {
          meta: {
            returnDate: moment(this.form.returnDate, 'DD/MM/YYYY').toISOString()
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/stages-header/components/popup-options-emandamento/PopOptionsEmandamento.vue